import { Header } from 'components/Header';
import type { FC } from 'react';
import { EmptyState, type IEmptyStateProps } from 'ui-library/components/EmptyState/EmptyState';
import s from './EmptyPage.module.scss';

interface IEmptyPageProps extends IEmptyStateProps {
  showHeader?: boolean;
}

export const EmptyPage: FC<IEmptyPageProps> = ({ showHeader = false, ...emptyStateProps }) => {
  'use memo';

  return (
    <div className={s.pageWrapper}>
      {showHeader && <Header />}
      <div className={s.content}>
        <EmptyState size="lg" variant="transparent" {...emptyStateProps} />
      </div>
    </div>
  );
};
